import React, { useEffect, useState } from 'react';
import { Box, Button, Grid, Alert, TextField, Typography } from '@mui/material';
import {
  IWizardFormStep,
  PrizeetAuthUser
} from '../../../../interface/interface';
import { useOrderManagementStore } from '../../../../zustandStore/store.ordermgt';
import SearchIcon from '@mui/icons-material/Search';
import AddressList from '../../../../components/AddressForm/AddressList';

export const AddressStepForm = (props: IWizardFormStep) => {
  const { onNext, onPrevious } = props;
  const [searchEmail, setSearchEmail] = useState('');
  const [currentEmail, setCurrentEmail] = useState('');
  const [selected, setSelected] = useState(false);

  // Handle search form submission
  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    setCurrentEmail(searchEmail.trim());
  };

  const orderMgtStore = useOrderManagementStore((state) => state);
  const authUser: PrizeetAuthUser = orderMgtStore.settings.authUser;

  useEffect(() => {
    if (authUser && authUser.email) {
      setSearchEmail(authUser.email);
      setCurrentEmail(authUser.email);
    }
  }, [orderMgtStore.settings.authUser]);

  const handleNext = () => {
    if (selected) {
      onNext(); // Only proceed if an address is selected
    }
  };

  const handleBack = () => {
    onPrevious();
  };

  return (
    <>
      {/* Display form-level errors if any */}

      <Grid
        sx={{
          flexDirection: 'column',
          gap: 2,
          width: 'auto'
        }}
        spacing={3}
      >
        <Grid spacing={3}>
          <Box
            sx={{
              padding: '2% 2%',
              width: '100%',
              border: '1px solid #e0e0e0',
              borderRadius: '8px'
            }}
          >
            <Box sx={{ mt: 3 }}>
              <Box
                component="form"
                onSubmit={handleSearch}
                sx={{
                  mb: 4,
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: 2
                }}
              >
                <TextField
                  fullWidth
                  label="Buyer Email"
                  variant="outlined"
                  value={searchEmail}
                  onChange={(e) => setSearchEmail(e.target.value)}
                  placeholder="Enter buyer email to manage addresses"
                  size="small"
                />
                <Button
                  type="submit"
                  variant="outlined"
                  color="primary"
                  startIcon={<SearchIcon />}
                  disabled={!searchEmail.trim()}
                >
                  Search
                </Button>
              </Box>

              {currentEmail ? (
                <AddressList
                  onSelectEvent={(lengthForm) => {
                    setSelected(lengthForm > 0);
                  }}
                  buyerEmail={currentEmail}
                  title={`Addresses for ${currentEmail}`}
                />
              ) : (
                <Typography
                  variant="body1"
                  color="textSecondary"
                  align="center"
                  sx={{ py: 4 }}
                >
                  Enter a buyer email address to manage their addresses
                </Typography>
              )}
            </Box>
          </Box>
        </Grid>
      </Grid>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: 3,
          mt: 5
        }}
        className="wizard-button"
      >
        <Button variant={'contained'} onClick={(e) => handleBack()}>
          Previous
        </Button>

        {}
        <Button
          disabled={!selected}
          variant={'contained'}
          onClick={(e) => handleNext()}
        >
          Next
        </Button>
      </Box>
    </>
  );
};
